exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".salaries-list-item .salaries-list-item__salary {\n  font-size: 3.4rem;\n}\n\n", ""]);

// exports
